import { MDBBtn, MDBModal, MDBModalBody, MDBModalContent, MDBModalDialog, MDBModalFooter, MDBModalHeader, MDBModalTitle, MDBAlert, MDBSpinner } from 'mdb-react-ui-kit'
import React, { useState } from 'react'
import { regenerateClientSecretInfo } from '../../../apiclients/streamsapi_bridge';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

function RegenerateClientSecretPopup(props) {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const [isError, setIsError] = useState(false)
    const [loading, setLoading] = useState(false);

    console.log("RegenerateClientSecretPopup info ::: " + JSON.stringify(props.Info));
    const regenerateClientSecret = async (info) => {
        console.log("regenerateClientSecret ::: " + JSON.stringify(info));
        try {
            setLoading(true)
            const siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
            const params = {
                client_id: info.client_id,
                client_secret: info.client_secret
            }
            const serverResponse = await regenerateClientSecretInfo(siteid, info.stream_app_id,params);
            if (!serverResponse.ok) {
                console.log("Network response was not ok");
                setIsError(true);
                setLoading(false)
            } else {
                const responseData = await serverResponse.json()
                console.log("responseData ::: : " + JSON.stringify(responseData));
                props.setOpen(false);
                localStorage.setItem("s_message", `Regenerated Client Secretsuccessfully.`);
                window.location.reload();
            }

        } catch (error) {
            console.log("Error  [getAccountStreamApiApps] " + error);
        }
    }
    
   return (
        <>
            <MDBModal tabIndex="-1" open={props.open} onClose={() => props.setOpen(false)} >
                <MDBModalDialog log>
                    <MDBModalContent>
                        <MDBModalHeader>
                            <MDBModalTitle>Regenerate Client Secret - {props.Info.appname}</MDBModalTitle>
                            <MDBBtn className="btn-close" color="none" onClick={() => { props.setOpen(false) }}></MDBBtn>
                        </MDBModalHeader>
                        <MDBModalBody><b>WARNING!</b> Regenerating this client secret will remove all access tokens if any created by using this Client ID and Client Secret. Are you sure you want to regenerate client secret of this API App?</MDBModalBody>
                        <MDBModalFooter>
                            <MDBBtn size="sm" color="secondary" onClick={() => { props.setOpen(false) }} >
                                Cancel
                            </MDBBtn>
                            <MDBBtn size="sm" color="primary" onClick={() => { regenerateClientSecret(props.Info) }}>
                                Regenerate 
                            </MDBBtn>
                        </MDBModalFooter>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>
             {isError && (
                <MDBAlert
                    open
                    className="alert-center"
                    color="danger"
                    autohide
                    position="bottom-right"
                    delay={100000}
                >
                    {t("Provisioning_Error_Aleart")}
                </MDBAlert>
            )}
            {loading && (
                <div>
                    <div className="loadingclass-popup"></div>
                    <div className="popup-bg-loader loader_align">
                        <MDBBtn disabled>
                            <MDBSpinner
                                size="sm"
                                role="status"
                                tag="span"
                                className="me-2"
                            />
                            Loading...
                        </MDBBtn>
                    </div>
                </div>
            )}
        </>
    )
}

export default RegenerateClientSecretPopup;